(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ingredient"] && !Shopify.designMode) return;
  try {
    
  const products = [
    {
      category: "CAKES",
      item: "Carrot Cake Batter (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium salt, xanthan gum, baking powder, canola oil (shortening), pasteurized eggs, water, vanilla bean extract, egg shade color, carrots, cinnamon, nutmeg, ginger, allspice, clove, beta carotene (color)",
      other: "Contains Soy"
    },
    {
      category: "CAKES",
      item: "Vanilla Cake Batter (DF)",
      ingredients: "sugar, water, white rice flour, eggs, corn syrup, salt, cellulose gum, canola oil (shortening), emulsifier, tapioca flour, corn starch, baking soda, baking powder, vanilla extract, palm oil, xanthan gum, calcium propionate (calcium & preservative)",
      other: "Contains Soy"
    },
    {
      category: "CAKES",
      item: "Chocolate Cake Batter (DF)",
      ingredients: "white rice flour, tapioca flour, sugar, water, salt, calcium propionate (calcium & preservative), cocoa powder, xanthan gum, baking powder, baking soda, soybean oil (shortening), pasteurized egg",
      other: "Contains Soy"
    },
    {
      category: "CAKES",
      item: "Red Velvet Cake Batter (DF)",
      ingredients: "white rice flour, tapioca flour, sugar, water, salt, calcium propionate (calcium & preservative), cocoa powder, xanthan gum, baking powder, baking soda, soybean oil (shortening), pasteurized egg, vanilla extract, egg shade color, natural & artificial coloring",
      other: "Contains Soy"
    },
    {
      category: "CAKES",
      item: "Vegan Vanilla Cake Batter",
      ingredients: "white rice flour, tapioca flour, sugar, water, baking powder, baking soda, canola oil, egg replacer blend (pea protein, chick pea, gum acacia, vegetable juice (color)), vanilla extract, xanthan gum, calcium propionate (calcium + preservative), salt",
      other: "Contains Soy"
    },
    {
      category: "CAKES",
      item: "Vegan Chocolate Cake Batter",
      ingredients: "white rice flour, tapioca flour, sugar, water, baking powder, baking soda, canola oil, egg replacer blend (pea protein, chick pea, gum acacia, vegetable juice (color)), cocoa powder, vanilla extract, xanthan gum, calcium propionate (calcium + preservative), salt",
      other: "Contains Soy"
    },
    {
      category: "PIES",
      item: "Blueberry Lattice Pie (V)",
      ingredients: "blueberries, food starch, preservatives, cinnamon, artificial color, white rice flour, palm oil, sugar, tapioca flour, xanthan gum, water, propylene glycol, vanilla extract, natural flavoring, caramel color, vegetable oil, vegetable color, sodium benzoate, soy lecithin, citric acid, salt, oats, calcium carbonate, stabilizers, gellan gum, vitamin A, vitamin D2, vitamin B2, vitamin B12, palm kernel oil, corn syrup, sodium citrate, artificial flavor, stabilizer, emulsifier, carbohydrate gum, beta carotene (color)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "PIES",
      item: "Apple Lattice Pie (V)",
      ingredients: "apples, corn starch, calcium lactate, cinnamon, preservatives, vitamin C, spices, turmeric, white rice flour, palm oil, sugar, tapioca flour, xanthan gum, water, propylene glycol, vegetable oil, vanillin, natural flavoring, caramel color, vegetable color, sodium benzoate, soy lecithin, citric acid, salt, oats, calcium carbonate, gellan gum, vitamin A, vitamin D2, vitamin B2, vitamin B12, palm kernel oil, corn syrup, sodium citrate, artificial flavors, disodium phosphate, emulsifier, carbohydrate gum, beta carotene (for color)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "PIES",
      item: "Cherry Lattice Pie (V)",
      ingredients: "cherries, food starch, preservatives, vitamin C, artificial colors, white rice flour, palm oil, sugar, tapioca flour, xanthan gum, water, propylene glycol, vanilla extract, caramel color, vegetable oil, vegetable color, sodium benzoate, soy lecithin, citric acid, salt, oats, calcium carbonate, stabilizer, gellan gum, vitamin A, vitamin D2, vitamin B2, vitamin B12, palm kernel oil, corn syrup, sodium citrate, artificial flavors, emulsifier, carbohydrate gum, beta carotene (for color)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Chocolate Chip Cookie Dough (V)",
      ingredients: "palm oil, white rice flour, brown sugar, sugar, water, potato flour, yellow corn meal, oats, calcium carbonate, stabilizer, salt, vitamin A, vitamin D2, vitamin B2, vitamin B12, tapioca flour, corn starch, PG (stabilizer), vanillin, natural flavor, caramel color, vegetable oil, xanthan gum, food preservative, soy lecithin, citric acid, baking soda, chocolate liquor, cocoa butter, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Sugar Cookie Dough (V)",
      ingredients: "palm oil, white rice flour, brown sugar, sugar, water, potato flour, yellow corn meal, oats, calcium carbonate, stabilizer, salt, vitamin A, vitamin D2, vitamin B2, vitamin B12, tapioca flour, corn starch, PG (stabilizer), vanillin, natural flavor, caramel color, vegetable oil, xanthan gum, food preservative, soy lecithin, citric acid, baking soda",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Reduced Sugar Chocolate Chip Cookies (V)",
      ingredients: "vanilla extract, oat milk, sugar, brown sugar, salt, white rice flour, potato flour, tapioca starch, corn starch, corn meal, xanthan gum, baking soda, water, vegetable oil, citric acid, soy lecithin, calcium propionate, chocolate chips",
      other: "Contains Soy"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Cookiewich (V)",
      ingredients: "vanilla extract, oat milk, sugar, brown sugar, salt, white rice flour, potato flour, tapioca starch, corn starch, corn meal, xanthan gum, baking soda, water, vegetable oil, citric acid, soy lecithin, shortening, calcium propionate, chocolate chips",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Chocolate Cigar",
      ingredients: "puff pastry, cocoa powder, powdered sugar, water, canola oil, ground cinnamon, chocolate chips",
      other: "Contains Soy"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Cream Puff",
      ingredients: "UNKNOWN",
      other: ""
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Turnovers (V)",
      ingredients: "puff pastry, filling (apple, blueberry, cherry)",
      other: ""
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Double Chocolate Chip Cookie (V)",
      ingredients: "vanilla extract, oat milk, sugar, brown sugar, white rice flour, potato flour, tapioca starch, corn starch, corn meal, xanthan gum, baking soda, water, propylene glycol (additive), vegetable oil, salt, soy lecithin, citric acid, calcium propionate (calcium + preservatives), cocoa powder, chocolate chips",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Black & White Cookie (V)",
      ingredients: "sugar, brown sugar, white rice flour, potato flour, tapioca starch, corn starch, corn meal, xanthan gum, baking powder, baking soda, calcium propionate (calcium + preservatives), vanilla extract, water, vegetable oil, salt, soy lecithin, citric acid, bittersweet chocolate, corn syrup, water, palm oil, vegetable oil, vitamin E, ascorbic acid, vitamin A, beta carotene, natural & artificial flavor, vegetable color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Linzer Tart (V)",
      ingredients: "vanilla extract, oat milk, sugar, brown sugar, white rice flour, potato flour, tapioca starch, corn starch, corn meal, xanthan gum, baking soda, water, propylene glycol (additive), vegetable oil, salt, soy lecithin, citric acid, calcium propionate (calcium + preservatives), cocoa powder, raspberry, pectin",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Rainbow Cookie (DF)",
      ingredients: "sugar, white rice flour, tapioca starch, salt, calcium propionate (calcium + preservatives), xanthan gum, baking powder, soy bean oil, pasteurized eggs, vanilla extract, almond flavor, raspberries, water, pectin, citric acid, corn syrup, apricot sugar, food starch, apple fibre powder, gellan gum, vegetable oil, cocoa powder, chocolate liquor",
      other: "CONTAINS SOY"
    },
    {
      category: "COOKIES & PASTRIES",
      item: "Hand Pies",
      ingredients: "pie shell, apple or blueberry filling",
      other: ""
    },
    {
      category: "MISC",
      item: "Oven Proof Apricot Filling",
      ingredients: "sugar, corn syrup, water, apricot puree, apples, citric acid, food starch, pectin, gellan gum, sodium citrate, sodium benzoate, artificial color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MISC",
      item: "Oven Proof Raspberry Filling",
      ingredients: "sugar, corn syrup, water, seedless raspberry puree, apples, food starch, pectin, gellan gum, artificial flavor, sodium acetate, sodium citrate, sodium benzoate, artificial color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Vanilla Frosting (V)",
      ingredients: "sugar, corn syrup, water, palm oil, vegetable oil, salt, soy lecithin, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, natural & artificial flavor, xanthan gum, vegetable color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Colored Frosting (V)",
      ingredients: "sugar, corn syrup, water, palm oil, vegetable oil, salt, soy lecithin, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, natural & artificial flavor, xanthan gum, natural & artificial color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "All Sprinkle Colors (V)",
      ingredients: "sugar, palm kernel oil, corn starch, sunflower preservative, sugar substitute, palm wax, vanillin, cellulose gum, natural & artificial color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Chocolate Frosting (V)",
      ingredients: "sugar, corn syrup, water, palm oil, vegetable oil, salt, soy lecithin, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, natural & artificial flavor, xanthan gum, vegetable color, cocoa powder, corn oil, chocolate liquor, TBHQ (antioxidant food preservative)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Fudge (V)",
      ingredients: "sugar, corn syrup, water, palm oil, palm shortening, cocoa powder, emulsifier, soybean oil, salt, soy lecithin, artificial flavors",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Whipped Cream (V)",
      ingredients: "palm kernel oil, water, high fructose preservative oil, xanthan gum, salt, sodium citrate, artificial flavors, preservatives, emulsifier, xanthan gum, beta carotene",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Cream Cheese Frosting (VEGAN)",
      ingredients: "water, sugar, palm oil, corn syrup, vegetable oil, emulsifier, salt, soy lecithin, sodium benzoate, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, natural & artificial flavors, xanthan gum, vegetable color preservative",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Ganache",
      ingredients: "sugar, corn syrup, water, palm oil, emulsifier, cocoa powder",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Lemon",
      ingredients: "water, sugar, dextrose, food starch, palm oil, lemon puree, citric acid, sodium citrate, salt, sorbic acid (preservative), agar, lemon oil, artificial colorants",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "ICINGS & SPRINKLES",
      item: "Strawberry",
      ingredients: "strawberries, high fructose corn syrup, water, sugar, carrageenan, calcium disodium EDTA, sodium benzoate, potassium sorbate, erythorbic acid, artificial flavor & color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Apple Crumb (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservative), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, brown sugar, apple filling (apples, water, high fructose corn syrup, starch, spices), cinnamon, clove, ginger, allspice, nutmeg, powdered sugar",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Blueberry Crumb (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservative), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, brown sugar, blueberries, cinnamon, clove, ginger, allspice, nutmeg",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Banana Chocolate Chip (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservative), baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, bananas, banana flavor, chocolate chips",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Cinnamon Crumb (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservative), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, brown sugar, cinnamon, clove, ginger, allspice, nutmeg",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Corn (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservatives), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, whole eggs, canola oil, egg shade color, corn meal, vegetable oil, propylene glycol",
      other: "CONTAINS SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Double Chocolate Chip (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservative), baking powder, baking soda, soybean oil (shortening), pasteurized egg, water, cocoa powder, vanilla extract, egg shade color, chocolate chips",
      other: "Contains Soy"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Gingerbread (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservatives), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, ginger, molasses, cinnamon, canola oil, clove, nutmeg, allspice",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Lemon Poppy (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservatives), xanthan gum, baking powder, soybean oil (shortening), pasteurized egg, water, vanilla extract, egg shade color, lemon oil, lemon yellow color, poppy seeds",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Marble (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservatives), xanthan gum, baking powder, baking soda, cocoa powder, soybean oil (shortening), pasteurized egg, egg shade color, water",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Pumpkin Crumb (DF)",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium propionate (calcium + preservatives), xanthan gum, brown sugar, baking powder, soybean oil (shortening), pasteurized eggs, water, vanilla extract, egg shade color, vegetable oil, pumpkin, ginger, cinnamon, canola oil, clove, nutmeg, allspice, natural & artificial coloring, soy lecithin, citric acid",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Vanilla Chocolate Chip (V)",
      ingredients: "sugar, egg replacer blend (pea protein, chick pea, gum acacia, vegetable juice (color)), calcium propionate (calcium + preservative), canola oil, vanilla extract, xanthan gum, baking soda, baking powder, salt, white rice flour, tapioca starch, chocolate chips",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Double Chocolate Chip (V)",
      ingredients: "sugar, egg replacer blend (pea protein, chick pea, gum acacia, vegetable juice (color)), calcium propionate (calcium + preservative), canola oil, vanilla extract, xanthan gum, baking soda, baking powder, salt, white rice flour, tapioca starch, cocoa, chocolate chips",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Blueberry (V)",
      ingredients: "sugar, egg replacer blend (pea protein, chick pea, gum acacia, vegetable juice (color)), calcium propionate (calcium + preservative), canola oil, vanilla extract, xanthan gum, baking soda, baking powder, salt, white rice flour, tapioca starch, blueberries",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "MUFFINS/SWEET LOAVES",
      item: "Pancakes & Waffles (V)",
      ingredients: "white rice flour, tapioca starch, sugar, canola oil, vanilla extract, tofu, baking powder, baking soda, salt, xanthan gum, oat milk, PAM cooking spray",
      other: "Contains Soy"
    },
    {
      category: "BREADS-DF",
      item: "Bread Sticks",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, soy lecithin, dimethyl silicone (anti-foaming agent)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Sandwich (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, soy lecithin, dimethyl silicone (anti-foaming agent)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Baguette (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Cinnamon Raisin Bread (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, soy lecithin, dimethyl silicone (anti-foaming agent), raisins, cinnamon",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Mock 'Rye' Bread (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, salt, soy lecithin, dimethyl silicone (anti-foaming agent), caraway seeds, caramel coloring, vegetable base (water, carrots, celery, cabbage, onion, parsley, turnips, parsnips), spices",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Multigrain (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, salt, soy lecithin, dimethyl silicone (anti-foaming agent), oats, caramel coloring, vegetable base (water, carrots, celery, cabbage, onion, parsley, turnips, parsnips), spices",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Runner's Bread (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, salt, soy lecithin, dimethyl silicone (anti-foaming agent), millet, sunflower seed, flax seed, cocoa powder",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Sourdough (DF)",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, yeast, emulsifier, vitamin C, salt, apple cider vinegar, xanthan gum, soy lecithin, dimethyl silicone (anti-foaming agent)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Challah (DF)",
      ingredients: "water, white rice flour, tapioca flour, canola oil, sugar, yeast, emulsifier, vitamin C, egg, corn syrup, vanillin, MCP (leavening agent), natural flavoring, baking soda, baking powder, corn flour, l-cysteine hydrochloride (flavor enhancer), potassium bromate, xanthan gum, artificial color, soy lecithin, dimethyl silicone (anti-foaming agent)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Irish Soda Bread",
      ingredients: "white rice flour, cornstarch, tapioca flour, sugar, eggs, water, salt, baking powder, baking soda, xanthan gum, calcium propionate (calcium + preservatives), canola oil, oat milk, palm oil, simple sugar, artificial flavoring",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Focaccia",
      ingredients: "white rice flour, cornstarch, tapioca flour, sugar, eggs, water, salt, yeast, xanthan gum, calcium propionate (calcium + preservatives), canola oil, corn syrup, tomato sauce, tomatoes, Italian seasoning",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Hamburger/Hot Dog Buns",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Plain/Salted Pretzel",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BREADS-DF",
      item: "Cinnamon Pretzel",
      ingredients: "corn starch, water, eggs, citric acid, canola oil, white rice flour, tapioca flour, sugar, corn syrup, tapioca syrup, yeast, emulsifier, vitamin C, salt, xanthan gum, cinnamon",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BAGELS-V",
      item: "Plain",
      ingredients: "water, corn starch, brown sugar, tapioca flour, white rice flour, yeast, emulsifier, vitamin C, cornmeal, l-cysteine hydrochloride (flavor enhancer), potassium bromate, salt, sugar, palm oil, canola oil, soy lecithin, dimethyl silicone (anti-foaming agent)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BAGELS-V",
      item: "misc toppings",
      ingredients: "sesame seeds, onion, poppy seeds, salt, cinnamon sugar, oat, everything topping (poppy seeds, sesame seeds, dried onion, salt)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "PIZZA",
      item: "Pizza Dough (V)",
      ingredients: "cornstarch, tapioca flour, white rice flour, yeast, brown sugar, sugar, salt, xanthan gum, water, corn meal, Reddi-Sponge Pareve*",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "PIZZA",
      item: "Pizza Dough (V)",
      ingredients: "cornstarch, tapioca flour, white rice flour, yeast, brown sugar, sugar, xanthan gum, water, corn meal, emulsifier, vitamin C, calcium propionate (calcium + preservatives), water, canola oil, BHT & BHA (antioxidants), PDMS (antifoaming)",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "PIZZA",
      item: "Mozzarella Cheese",
      ingredients: "pasteurized milk, cheese cultures, salt, enzymes, modified food starch",
      other: ""
    },
    {
      category: "PIZZA",
      item: "Pizza/Marinara Sauce",
      ingredients: "tomatoes, onions, carrots, sugar, salt, garlic, spices, natural flavor, olive oil, canola oil, safflower oil, citric acid, vitamin E, water, MSG, chicken fat, powdered chicken broth, corn protein, soy protein, whey, yeast, turmeric, soy lecithin, spices, flavor enhancer, citric acid, tartaric acid, natural flavor, parsley, oregano, black pepper",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "GRANOLA",
      item: "Maple-Cinnamon Granola",
      ingredients: "oats, maple syrup, honey, cinnamon, vanilla, brown sugar, corn syrup, soybean oil, salt",
      other: ""
    },
    {
      category: "BROWNIES-DF",
      item: "Brownie",
      ingredients: "sugar, eggs, palm oil, white rice flour, chocolate liquor, cocoa powder, simple syrup, soy lecithin, vanillin, xanthan gum, salt, canola oil, PDMS, natural & artificial flavorings",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BROWNIES-DF",
      item: "Fudge Brownie",
      ingredients: "sugar, eggs, palm oil, white rice flour, chocolate liquor, cocoa powder, simple syrup, soy lecithin, vanillin, xanthan gum, salt, canola oil, PDMS, natural & artificial flavorings, palm shortening, emulsifier, cocoa butter",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BROWNIES-DF",
      item: "Brookie",
      ingredients: "sugar, eggs, palm oil, white rice flour, chocolate liquor, cocoa powder, simple syrup, soy lecithin, vanillin, xanthan gum, salt, canola oil, PDMS, natural & artificial flavorings, brown sugar, water, potato flour, yellow corn meal, oats, calcium carbonate, stabilizer, salt, vitamin A, vitamin D2, vitamin B2, vitamin B12, tapioca flour, corn starch, PG (stabilizer), food preservative, soy lecithin, citric acid, baking soda, cocoa butter, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BROWNIES-DF",
      item: "S'mores",
      ingredients: "sugar, eggs, palm oil, white rice flour, chocolate liquor, cocoa powder, simple syrup, soy lecithin, vanillin, xanthan gum, salt, canola wireframe oil, PDMS, natural & artificial flavorings, water, vegetable oil, salt, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, vegetable color, brown sugar, potato flour, yellow corn meal, oats, calcium carbonate, stabilizer, salt, vitamin D2, vitamin B2, vitamin B12, tapioca flour, corn starch, PG (stabilizer), vanillin, natural flavor, caramel color, food preservative, baking soda, gelatin",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "BROWNIES-DF",
      item: "Oreo",
      ingredients: "sugar, eggs, palm oil, white rice flour, chocolate liquor, cocoa powder, simple syrup, soy lecithin, vanillin, xanthan gum, salt, canola oil, PDMS, natural & artificial flavorings, water, vegetable oil, salt, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, corn starch, vegetable color, tapioca flour, baking soda, cocoa butter",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Vanilla Donut",
      ingredients: "sugar, water, white rice flour, eggs, corn syrup, salt, cellulose gum, soybean oil (shortening), emulsifier, tapioca flour, corn starch, baking soda, baking powder, vanilla extract, palm oil, xanthan gum, calcium propionate (calcium & preservative), canola oil, soy lecithin, silicon dioxide (anti-caking), vegetable oil, cocoa powder, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Chocolate Donut",
      ingredients: "white rice flour, tapioca flour, sugar, water, salt, calcium propionate (calcium & preservative), cocoa powder, xanthan gum, baking powder, baking soda, soybean oil (shortening), pasteurized egg, canola oil, soy lecithin, silicone dioxide (anti-caking), vegetable oil, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Cake Ball- Vanilla",
      ingredients: "sugar, water, white rice flour, eggs, corn syrup, salt, cellulose gum, soybean oil (shortening), emulsifier, tapioca flour, corn starch, baking soda, baking powder, vanilla extract, palm oil, xanthan gum, calcium propionate (calcium & preservative), canola oil, soy lecithin, silicone dioxide (anti-caking), vegetable oil, cocoa powder, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Cake Ball- Chocolate",
      ingredients: "white rice flour, tapioca flour, sugar, water, salt, calcium propionate (calcium & preservative), cocoa powder, xanthan gum, baking powder, baking soda, soybean oil (shortening), pasteurized egg, canola oil, soy lecithin, silicone dioxide (anti-caking), vegetable oil, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Cake Ball- Red Velvet",
      ingredients: "white rice flour, tapioca flour, sugar, water, salt, calcium propionate (calcium & preservative), cocoa powder, xanthan gum, baking powder, baking soda, soybean oil (shortening), pasteurized egg, vanilla extract, egg shade color, natural & artificial coloring, canola oil, soy lecithin, silicone dioxide (anti-caking), vegetable oil, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute, emulsifier, sodium benzoate, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, natural & artificial flavors, vegetable color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "DONUTS & CAKE BALLS",
      item: "Cake Ball- Carrot",
      ingredients: "sugar, white rice flour, tapioca flour, salt, calcium salt, xanthan gum, baking powder, soybean oil (shortening), pasteurized eggs, water, vanilla bean extract, egg shade color, carrots, cinnamon, nutmeg, ginger, allspice, clove, beta carotene (color), canola oil, soy lecithin, silicone dioxide (anti-caking), vegetable oil, chocolate liquor, vanillin, palm kernel oil, sunflower emulsifier, palm wax, sugar substitute, emulsifier, sodium benzoate, vitamin E, ascorbic acid, citric acid, vitamin A, beta carotene, natural & artificial flavors, vegetable color",
      other: "MAY CONTAIN SOY"
    },
    {
      category: "CANNOLI",
      item: "Cannoli Cream (CD)",
      ingredients: "impastata ricotta (whole milk, vinegar, salt), cane sugar, chocolate drops (sugar, chocolate liquor, cocoa butter, soya lecithin, vanilla), vanilla, cinnamon oil",
      other: ""
    },
    {
      category: "CANNOLI",
      item: "Cannoli Shell (DF)",
      ingredients: "rice flour, corn starch, tapioca dextrin, xanthan gum, rice extract, whole eggs, butter, vegetable shortening, sugar, salt",
      other: ""
    },
    {
      category: "DRESSING-VEGAN",
      item: "Balsamic Vinaigrette",
      ingredients: "water, vinegar (balsamic, red wine), olive oil, corn syrup, salt, garlic, xanthan gum, spices, sodium alginate (thickener), emulsifier, preservatives",
      other: ""
    },
    {
      category: "DRESSING-VEGAN",
      item: "BBQ Sauce",
      ingredients: "distilled vinegar, tomato paste, corn starch, corn syrup, salt, pineapple juice, natural smoke flavors, spices, caramel color, sodium benzoate, molasses, dried garlic, sugar, tamarind, mustard flour, celery seed",
      other: ""
    },
    {
      category: "DRESSING-VEGAN",
      item: "Ketchup",
      ingredients: "red ripe tomatoes, distilled vinegar, corn syrup, salt, spice, onion powder, natural flavoring",
      other: ""
    },
    {
      category: "DRESSING-VEGAN",
      item: "Spicy Mayo",
      ingredients: "vinegar, water, mustard seed, salt, spices, turmeric",
      other: ""
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Chipotle Mayo",
      ingredients: "mayo, chipotle puree, soybean oil, water, chipotle chilies in adobo (water, red jalapeño peppers, chipotle peppers), tomato paste, vinegar, salt, oleoresin capsicum, salted egg yolk, distilled vinegar, sugar, cilantro, dehydrated garlic, natural smoke flavor, mustard seed, potassium sorbate, sodium benzoate, marjoram, lemon juice concentrate, EDTA",
      other: "CONTAINS EGG"
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Greek",
      ingredients: "mayo, lemon, garlic, Worcestershire sauce, white vinegar, sugar, Italian seasonings, oregano, dill, salt, pepper, water",
      other: "CONTAINS EGG"
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Honey Mustard",
      ingredients: "water, sugar, mustard seed, vinegar, mustard flour, salt, honey, caramel color, sodium metabisulfite, citric acid, turmeric",
      other: ""
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Mayo",
      ingredients: "soybean oil, egg yolks, vinegar, water, salt, sugar, natural flavors, calcium disodium, citric acid, lemon juice concentrate, EDTA (to protect flavor)",
      other: "CONTAINS EGG"
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Pesto",
      ingredients: "basil, garlic clove, olive oil, salt, lemon juice",
      other: ""
    },
    {
      category: "DRESSING-DAIRY FREE",
      item: "Santa Fe",
      ingredients: "mayo, chipotle sauce, honey, sugar, canola oil, white vinegar",
      other: "CONTAINS EGG"
    },
    {
      category: "SOUPS",
      item: "Matzo Ball Soup",
      ingredients: "Manschewitz gluten-free matzo ball mix, eggs, canola oil, water, celery, onions, carrots, dill, black pepper, Knorr Gluten Free Chicken Flavor Base",
      other: "CONTAINS CHICKEN, EGG"
    },
    {
      category: "SOUPS",
      item: "Creamy Tomato",
      ingredients: "vegetable stock (water, carrots, onions, celery, salt, sugar, corn oil, potato flour, carrot powder), heavy cream, tomato paste, sugar, butter, corn starch, garlic, nonfat dry milk, extra virgin olive oil, basil, salt, tomato concentrate, citric acid, spices",
      other: "CONTAINS MILK"
    },
    {
      category: "SOUPS",
      item: "Chicken Tortilla",
      ingredients: "water, tomato, white chicken meat, corn, Monterey Jack cheese, onions, tortilla chips (corn flour, sunflower oil, salt), carrots, chicken base (chicken fat, sugar, natural flavors, safflower oil, chicken broth, turmeric), scallions, lime juice, jalapeno peppers, canola oil, garlic, cilantro, distilled vinegar, salt, spices",
      other: "CONTAINS MILK"
    },
    {
      category: "SOUPS",
      item: "Beef Chili",
      ingredients: "tomatoes, water, kidney beans (kidney beans, water, salt, calcium chloride), black beans, seasoned beef, red bell peppers, green bell peppers, yellow bell peppers, onions, beef broth base, vinegar, apple cider vinegar, lime juice, garlic, cilantro, carrot powder, yeast extract, celery seed, spice",
      other: "DAIRY FREE"
    },
    {
      category: "SOUPS",
      item: "Clam Chowder",
      ingredients: "cream, clam broth (water, clam juice, salt), potatoes, clam meat, onions, butter, garlic, fish stock, corn starch, salt, spices",
      other: "CONTAINS MILK"
    }
  ];

  const itemsPerPage = 10;
  let currentPage = 1;
  let currentProducts = products;

  function renderProductCards(searchTerm = '') {
    const resultsContainer = document.getElementById('product-results');
    resultsContainer.innerHTML = ''; // Clear previous results

    // Filter products based on search term
    currentProducts = searchTerm
      ? products.filter(product => product.item.toLowerCase().includes(searchTerm.toLowerCase()))
      : products;

    if (currentProducts.length === 0) {
      resultsContainer.innerHTML = `
        <div class="no-results">
          No products found matching "${searchTerm}". Please try another search.
        </div>
      `;
      renderPagination(1, 0);
      return;
    }

    // Calculate pagination
    const totalPages = Math.ceil(currentProducts.length / itemsPerPage);
    currentPage = Math.min(currentPage, totalPages);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedProducts = currentProducts.slice(startIndex, endIndex);

    // Render product cards
    paginatedProducts.forEach(product => {
      const card = document.createElement('div');
      card.className = 'ingredient-card';
      card.innerHTML = `
        <h2>${product.item}</h2>
        <p><strong>Category:</strong> ${product.category}</p>
        <p><strong>Ingredients:</strong> ${product.ingredients}</p>
        <p><strong>Other:</strong> ${product.other || 'None'}</p>
      `;
      resultsContainer.appendChild(card);
    });

    // Render pagination controls
    renderPagination(currentPage, totalPages);
  }

  function renderPagination(currentPage, totalPages) {
    const paginationContainer = document.getElementById('pagination');
    paginationContainer.innerHTML = '';

    // Previous button
    const prevButton = document.createElement('button');
    prevButton.textContent = 'Previous';
    prevButton.disabled = currentPage === 1;
    prevButton.addEventListener('click', () => {
      if (currentPage > 1) {
        currentPage--;
        renderProductCards(document.getElementById('product-search').value.trim());
      }
    });
    paginationContainer.appendChild(prevButton);

    // Page number buttons (show up to 5 pages around current page)
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    startPage = Math.max(1, endPage - maxPagesToShow + 1);

    for (let i = startPage; i <= endPage; i++) {
      const pageButton = document.createElement('button');
      pageButton.textContent = i;
      pageButton.className = i === currentPage ? 'active' : '';
      pageButton.addEventListener('click', () => {
        currentPage = i;
        renderProductCards(document.getElementById('product-search').value.trim());
      });
      paginationContainer.appendChild(pageButton);
    }

    // Next button
    const nextButton = document.createElement('button');
    nextButton.textContent = 'Next';
    nextButton.disabled = currentPage === totalPages;
    nextButton.addEventListener('click', () => {
      if (currentPage < totalPages) {
        currentPage++;
        renderProductCards(document.getElementById('product-search').value.trim());
      }
    });
    paginationContainer.appendChild(nextButton);
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    renderProductCards(); // Show first 10 products initially

    const searchInput = document.getElementById('product-search');
    const searchBtn = document.getElementById('search-btn');

    // Search on button click
    searchBtn.addEventListener('click', () => {
      currentPage = 1; // Reset to first page on new search
      renderProductCards(searchInput.value.trim());
    });

    // Search on Enter key
    searchInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        currentPage = 1; // Reset to first page on new search
        renderProductCards(searchInput.value.trim());
      }
    });

    // Real-time search as user types
    searchInput.addEventListener('input', () => {
      currentPage = 1; // Reset to first page on new search
      renderProductCards(searchInput.value.trim());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
